import Icon from 'veui/components/Icon'

Icon.register({
  'file-zip': {
    paths: [
      {
        fill: '#faab21',
        d: 'M27.7 9.81l-6.68-8A1.34 1.34 0 0020 1.33H6a2 2 0 00-2 2v25.34c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.05-.07-.56-.3-.86z'
      },
      {
        fill: '#ffd676',
        d: 'M21.02 1.81A1.34 1.34 0 0020 1.33v7.34c0 1.1.9 2 2 2h6c0-.05-.07-.56-.3-.86z'
      },
      {
        fill: '#fff',
        d: 'M10.67 2.67v2H8.64A.64.64 0 018 4.03V3.3c0-.35.29-.63.64-.63zm2.03 2h-2.03v2h2.03c.35 0 .63-.29.63-.64V5.3a.64.64 0 00-.63-.63zM8 7.3v.73c0 .35.28.64.64.64h2.03v-2H8.64A.64.64 0 008 7.3zm5.33 2.73V9.3a.64.64 0 00-.63-.63h-2.03v2h2.03c.35 0 .63-.29.63-.64zm-4.7 2.64h2.04v-2H8.64a.64.64 0 00-.64.63v.73c0 .35.28.64.64.64zm2.04 2v-2h2.03c.35 0 .63.28.63.63v5.37c0 .73-.6 1.33-1.33 1.33H9.33C8.6 20 8 19.4 8 18.67V15.3c0-.35.28-.63.64-.63zM12 17.33H9.33v1.34H12z'
      }
    ],
    width: '32',
    height: '32'
  }
})
